<template>
	<div class="bg-w pd20">
		
		<div class="flex center alcenter">
			<div style="width: 400px;" class="count-box-item  flex alcenter center">
				<div class="text-center" >
					<div class="ft18 ftw600 cl-red">{{datas.cash}}元</div>
					<div class="mt16 ft14 cl-notice">总金额</div>
				</div>
			</div>
		</div>
		<div class="mt20">
			
			<ve-line :data="chartLineData" ></ve-line>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			}
		},
		computed:{
			chartLineData(){
				return {
					columns: ['日期', '金额'],
					rows: this.datas.tables
				}
			}
		},
		data(){
	
			return {
				
				
			}
		}
	}
</script>

<style>
	.count-box-item{
		height: 126px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
	}
</style>